<div class="container-fluid pb-5">
    <div class="d-flex align-items-center justify-content-between mb-2">
        <h4 class="main-heading">Drug List Detail</h4>
        <button class="btn" mat-icon-button (click)="dialogRef.close()" type="button">
            <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
        </button>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card shadow-sm">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="acute">
                                <div class="acute-content">
                                    <ng-template #noChronicData>
                                        <div
                                            class="d-flex flex-column align-items-center w-100 justify-content-center noAcuteDataFound">
                                            <img src="assets/images/emptystate.png" alt="no data found icon"
                                                class="mb-3" />
                                            <div class="bold">No Data Found</div>
                                        </div>
                                    </ng-template>

                                    <div class="acuteDataFound">

                                        <div class="pagination-table">
                                            <table class="table table-striped p-dash" aria-describedby="Users table">
                                                <thead>
                                                    <tr>
                                                        <th class="d-none"></th>
                                                        <th>Rx Num</th>
                                                        <th>Drug Name</th>
                                                        <th>Dosage</th>
                                                        <th>Repeats</th>
                                                        <th>Quantity</th>
                                                        <th>Strength</th>
                                                        <th>Dosage Form</th>
                                                        <th>Instructions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of DrugList">
                                                        <td>{{ item?.rxNum || '-'}}</td>
                                                        <td>{{ item?.drugName || '-'}}</td>
                                                        <td>{{ item?.dosage || '-'}}</td>
                                                        <td>{{ item?.repeats || '-'}}</td>
                                                        <td>{{ item?.quantity || '-'}}</td>
                                                        <td>{{ item?.strength || '-'}}</td>
                                                        <td>{{ item?.dosageForm || '-'}}</td>
                                                        <td>{{ item?.instructions || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>